export default "__VITE_ASSET__B_YWaU72__"